var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome1Br({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 337,
    height: 367,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken",
      fill: "#bfa1d6",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#D096FE",
    rx: 66.891,
    ry: 77.715,
    style: {
      fill: "#bfa1d6",
      fillOpacity: 1
    },
    transform: "matrix(-.99196 -.12877 .12929 -.99132 127.835 134.568)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 6,
    d: "m106.439 82.176-36.754 70.771 26.163 5.71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 6,
    d: "M93.386 107.658C47.913 132.75 52.444 94.516 52.444 94.516M154.968 124.025c-25.741 24.181-40.357-2.611-40.357-2.611M77.302 161.69c4.284 23.115 31.2 22.425 38.339 12.239"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 1,
      fill: "#77c69b",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "m205.221.496 112.978 366.366-202.503-3.29L205.221.496Z",
    style: {
      fill: "#77c69b",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#518d64",
      fillOpacity: 1,
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29AB87",
    d: "m277.867 206.105 8.745-5.852 8.624-6.327 7.248-7.912 7.857-9.472 7.833-9.414 7.702-9.361 5.314-10.343 5.208-9.585-9.505-.992-10.999 1.763-10.975 1.705-9.463 4.999-9.571 4.114-9.446 4.706-12.132 8.996-9.551 11.807-6.378 10.18-4.65 10.431-3.644 10.473-2.065 10.189-.863 9.769 7.303-1.568 11.373-4.8L267 213.393l10.867-7.288Z",
    style: {
      fill: "#518d64",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#518d64",
      fillOpacity: 1,
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29AB87",
    d: "m265.115 229.837 6.438.536 6.56.261 6.507-1.026 7.395-1.542 7.362-1.524 7.278-1.549 6.508-2.933 6.167-2.61-4.184-4.112-5.955-3.361-5.922-3.379-6.455-1.22-6.169-1.686-6.336-1.353-9.266-.322-9.102 2.016-6.956 2.448-6.223 3.229-5.755 3.635-4.889 4.102-4.151 4.361 4.105 2.04 7.297 2.046 7.741 1.286 8.005.657Z",
    style: {
      fill: "#518d64",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome1Br);
export default __webpack_public_path__ + "static/media/bg_home1_br.5d4c9a87022ac0a287914084911da728.svg";
export { ForwardRef as ReactComponent };